module.exports = __webpack_public_path__ + "assets/img/fncfour.6045d8b7.png";